import React, { Component } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
class DeleteButton extends Component {
  state = {};

  render() {
    return (
      <div className="text-center">
        <button
          onClick={() => {
            this.props.onDelete(this.props.ideaId);
          }}
          className="btn btn-outline-danger btn-sm  "
        >
          <FontAwesomeIcon icon="trash-alt" />
        </button>
      </div>
    );
  }
}

export default DeleteButton;
